import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { CATEGORIES, SITE } from "@/mocks/gossip";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const goAnchor = (id: string) => {
    setOpen(false);
    if (location.pathname === "/") {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      navigate(`/#${id}`);
    }
  };

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/90 backdrop-blur-md border-b border-background-200"
          : "bg-transparent"
      }`}
    >
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex h-16 md:h-[72px] items-center justify-between gap-4">
          {/* 品牌 */}
          <Link to="/" className="flex items-center gap-2.5 shrink-0">
            <span className="w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-2xl bg-primary-500 text-background-50">
              <i className="ri-fire-line text-xl md:text-2xl"></i>
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading text-2xl md:text-[26px] text-foreground-950 tracking-wide">
                九一吃瓜
              </span>
              <span className="text-[11px] md:text-xs text-foreground-500 mt-1 hidden sm:block">
                {SITE.slogan}
              </span>
            </span>
          </Link>

          {/* 桌面导航 */}
          <nav className="hidden lg:flex items-center gap-1">
            <button
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              className="px-4 py-2 rounded-full text-sm text-foreground-700 hover:bg-background-100 hover:text-primary-600 transition whitespace-nowrap"
            >
              首页
            </button>
            {CATEGORIES.slice(0, 5).map((c) => (
              <button
                key={c.id}
                onClick={() => goAnchor("feed")}
                className="px-4 py-2 rounded-full text-sm text-foreground-700 hover:bg-background-100 hover:text-primary-600 transition whitespace-nowrap"
              >
                {c.name}
              </button>
            ))}
          </nav>

          <div className="flex items-center gap-2.5">
            <Link
              to="/search"
              aria-label="搜索"
              className="w-10 h-10 md:w-11 md:h-11 hidden sm:flex items-center justify-center rounded-full bg-background-100 text-foreground-700 hover:bg-accent-500 hover:text-background-50 transition"
            >
              <i className="ri-search-line text-lg"></i>
            </Link>
            <a
              href="#contact"
              onClick={(e) => {
                e.preventDefault();
                goAnchor("contact");
              }}
              className="hidden md:inline-flex items-center gap-2 rounded-full bg-primary-500 text-background-50 text-sm font-medium px-5 py-2.5 hover:bg-primary-600 transition whitespace-nowrap"
            >
              <i className="ri-megaphone-line"></i>
              前排投稿
            </a>
            {/* 移动端菜单按钮 */}
            <button
              aria-label="菜单"
              onClick={() => setOpen(!open)}
              className="lg:hidden w-10 h-10 flex items-center justify-center rounded-full bg-background-100 text-foreground-800"
            >
              <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-xl`}></i>
            </button>
          </div>
        </div>
      </div>

      {/* 移动端下拉菜单 */}
      <div
        className={`lg:hidden overflow-hidden transition-all duration-300 bg-background-50/95 backdrop-blur-md border-b border-background-200 ${
          open ? "max-h-[420px]" : "max-h-0"
        }`}
      >
        <nav className="px-4 py-3 grid grid-cols-2 gap-1">
          <button
            onClick={() => {
              setOpen(false);
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
            className="flex items-center gap-2 rounded-lg px-3 py-2.5 text-sm text-foreground-800 hover:bg-background-100"
          >
            <i className="ri-home-4-line text-primary-500"></i> 首页
          </button>
          {CATEGORIES.map((c) => (
            <button
              key={c.id}
              onClick={() => goAnchor("feed")}
              className="flex items-center gap-2 rounded-lg px-3 py-2.5 text-sm text-foreground-800 hover:bg-background-100"
            >
              <i className={`${c.icon} text-accent-500`}></i> {c.name}
            </button>
          ))}
          <a
            href="#contact"
            onClick={(e) => {
              e.preventDefault();
              goAnchor("contact");
            }}
            className="flex items-center gap-2 rounded-lg px-3 py-2.5 text-sm font-medium text-primary-600"
          >
            <i className="ri-megaphone-line"></i> 前排投稿
          </a>
        </nav>
      </div>
    </header>
  );
}